export const loginData = {
  tenantId: "54",
  memberSchemaId: "66669509",
  fields: [
    {
      id: "4788",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "mobile",
      displayName: "手机",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(?!(0|86))\\d+$",
      textLength: "11",
      textRegularId: "17",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "2",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "1",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.mobile",
      identFieldName: "mbr_identification.mobile",
      displayType: "1",
      isLogin: "1",
      versionNumber: "5",
      isSendSms: "1",
      isFormed: "1",
      fieldId: "5001",
      aliasName: "",
      regularExpression: "^(?!(0|86))\\d+$",
      description: "国际手机号",
    },
    {
      id: "4789",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "email",
      displayName: "邮箱",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      textLength: "0",
      textRegularId: "11",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "3",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "0",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.email",
      identFieldName: "mbr_identification.email",
      displayType: "1",
      isLogin: "1",
      versionNumber: "3",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5002",
      aliasName: "",
      regularExpression: "^(\\w)+(.|-\\w+)*@(.|-|\\w)+((\\.\\w+)+)$",
      description: "邮箱格式",
    },
    {
      id: "4790",
      tenantId: "54",
      schemaId: "66669509",
      formId: "66669651",
      fieldName: "identityNum",
      displayName: "身份证",
      fieldType: "TEXT",
      fileLimitType: "",
      textLimitType: "SYSTEM",
      textRegularExpression: "^(^\\d{15}$|^\\d{18}$|^\\d{17}(\\d|X|x))$",
      textLength: "18",
      textRegularId: "12",
      listOptionType: "",
      listDictId: "0",
      listLimitType: "",
      maxOptionId: "0",
      dateLimitType: "",
      orderId: "4",
      deleted: "0",
      isSystemed: "1",
      isShow: "0",
      required: "0",
      enabled: "1",
      errorMessage: "",
      isOverWrite: "1",
      isRecordHistory: "1",
      isExport: "1",
      memberFieldName: "mbr_member.identityNum",
      identFieldName: "mbr_identification.identityNum",
      displayType: "1",
      isLogin: "1",
      versionNumber: "8",
      isSendSms: "0",
      isFormed: "1",
      fieldId: "5003",
      aliasName: "",
      regularExpression: "^(^\\d{15}$|^\\d{18}$|^\\d{17}(\\d|X|x))$",
      description: "身份证",
    },
  ],
  type: ["normal", "third", "checkcode"],
  default: "normal",
  thirdBind: 1,
  oauthInfo: {
    qq: {
      loginUrl: "https://dev-wxoauthb.smarket.net.cn/oauth/qq/login",
      callbackUrl: "https://dev-wxoauthb.smarket.net.cn/oauth/qq/callback",
      accountType: -1,
      isCertified: -1,
    },
  },
};
